// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wLs8","content":"styles_content__2SDkM"};